import { render, staticRenderFns } from "./URL.vue?vue&type=template&id=221ea5a6&scoped=true&"
import script from "./URL.vue?vue&type=script&lang=js&"
export * from "./URL.vue?vue&type=script&lang=js&"
import style0 from "./URL.vue?vue&type=style&index=0&id=221ea5a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221ea5a6",
  null
  
)

export default component.exports